import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { BOAT_CATEGORIES, SOCIO_CATEGORIES, slug } from "@/lib/api";

export const EMPTY_FILTERS = { q: "", categoria_socio: "all", categoria_barca: "all", pagamento: "all", metodo: "all" };

export const applyFilters = (items, f) => {
  const q = f.q.trim().toLowerCase();
  return items.filter((m) =>
    (!q || `${m.cognome} ${m.nome} ${m.tessera_numero}`.toLowerCase().includes(q)) &&
    (f.categoria_socio === "all" || m.categoria_socio === f.categoria_socio) &&
    (f.categoria_barca === "all" || (f.categoria_barca === "none" ? !m.categoria_barca : m.categoria_barca === f.categoria_barca)) &&
    (f.pagamento === "all" || (f.pagamento === "ok") === !!m.pagamento_confermato) &&
    (f.metodo === "all" || m.metodo_pagamento === f.metodo)
  );
};

const F = ({ value, onChange, options, testid, w = "w-44" }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className={w} data-testid={testid}><SelectValue /></SelectTrigger>
    <SelectContent>{options.map(([v, l]) => <SelectItem key={v} value={v} data-testid={`${testid}-option-${slug(v)}`}>{l}</SelectItem>)}</SelectContent>
  </Select>
);

export const FiltriSoci = ({ f, setF, payments = true }) => {
  const set = (k) => (v) => setF({ ...f, [k]: v });
  return (
    <div className="flex flex-wrap gap-2 mb-5" data-testid="libro-soci-filters">
      <div className="relative w-full sm:w-64">
        <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input className="pl-9" placeholder="Cognome, nome o n. tessera" value={f.q} onChange={(e) => set("q")(e.target.value)} data-testid="libro-soci-search-input" />
      </div>
      <F value={f.categoria_socio} onChange={set("categoria_socio")} w="w-56" testid="libro-soci-filter-categoria" options={[["all", "Tutte le categorie socio"], ...SOCIO_CATEGORIES.map((c) => [c, c])]} />
      <F value={f.categoria_barca} onChange={set("categoria_barca")} testid="libro-soci-filter-barca" options={[["all", "Tutte le classi"], ["none", "Senza barca"], ...BOAT_CATEGORIES.map((c) => [c, c])]} />
      {payments && <F value={f.pagamento} onChange={set("pagamento")} testid="libro-soci-filter-pagamento" options={[["all", "Tutti i pagamenti"], ["ok", "Pagamento confermato"], ["pending", "Da confermare"]]} />}
      {payments && <F value={f.metodo} onChange={set("metodo")} w="w-36" testid="libro-soci-filter-metodo" options={[["all", "Bon e contanti"], ["bonifico", "Bon"], ["delegato", "Contanti"]]} />}
      <button onClick={() => setF(EMPTY_FILTERS)} className="text-sm text-emerald-700 hover:underline px-2" data-testid="libro-soci-reset-filters">Azzera filtri</button>
    </div>
  );
};
